import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge";
import MenuIcon from "@mui/icons-material/Menu";
import { Button } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import { ACCENT_BLUE, WHITE } from "../colors";
import ChangePasswordModel from "../components/ChangePasswordModel";

import {
  CUSTOMER_LIST_PAGE,
  DASHBOARD_PAGE,
  EMPLOYEES_PAGE,
  FINANCIAL_PAGE,
  FORMS_PAGE,
  FORM_EDIT_PAGE,
} from "./data";
import { useDispatch } from "react-redux";
import { logout } from "../actions/auth";
import { useHistory } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FormEditService from "../services/formEditService";
import LogoImg from "../images/logo.png";

const CustomToolBar = styled(Toolbar)(({ theme }) => ({
  backgroundColor: WHITE,
  boxShadow: "none",
}));

const CustomMenu = styled(Menu)(({ theme }) => ({
  maxHeight: 300,
  width: 200,
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 300,
    maxHeight: 600,
    backgroundColor: WHITE,
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
    },
  },
}));

export default function AppToolBar(props) {
  const { selectedPage } = props;
  const dispatch = useDispatch();
  let history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function logOutTheUser() {
    dispatch(logout());
    history.push("/login");
  }
  const [screenInfo, setScreenInfo] = React.useState({
    screenName: "",
    formEdits: [],
  });
  const getPageInfo = async () => {
    const res = await FormEditService.getAllDraftFormEdits();
    setScreenInfo({
      ...screenInfo,
      formEdits: res.data,
    });
  };

  const [openChangePasswordModel, setOpenChangePasswordModel] = React.useState(
    false
  );

  const user = JSON.parse(localStorage.getItem("user"));
  const userData = user?.data;
  React.useEffect(() => {
    getPageInfo();
  }, []);
  return (
    <CustomToolBar>
      <Box sx={{ flexGrow: 1 }} />
      <ChangePasswordModel
        openModel={openChangePasswordModel}
        okFunction={() => {}}
        user={userData}
        cancelFunction={() => {
          setOpenChangePasswordModel(false);
        }}
      />

      <div>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="primary"
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <Badge badgeContent={screenInfo.formEdits.length} color="error">
            <NotificationsNoneOutlinedIcon />
          </Badge>
        </IconButton>
        <CustomMenu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          PaperProps={{
            style: {
              maxHeight: 500,
            },
          }}
        >
          {screenInfo?.formEdits?.map((item) => (
            <MenuItem
              onClick={() => history.push(`/form-edits/1`)}
              key={item?.id}
            >
              Review {item?.type} pending
              {/* Review {item?.type} for {item?.Customer.name} pending */}
            </MenuItem>
          ))}
        </CustomMenu>
      </div>
      <IconButton
        onClick={() => setOpenChangePasswordModel(true)}
        size="large"
        aria-label="show 17 new notifications"
        color="primary"
      >
        <Badge>
          <SettingsIcon />
        </Badge>
      </IconButton>

      <IconButton
        onClick={() => logOutTheUser()}
        size="large"
        aria-label="show 17 new notifications"
        color="primary"
      >
        <Badge>
          <LogoutIcon />
        </Badge>
      </IconButton>
    </CustomToolBar>
  );
}